module.exports = __webpack_public_path__ + "img/01-424-424.f01d65de.png";